import { FC, Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Container } from '@mui/material'
import { Logo } from 'components/features/auth/Logo'
import { Loader } from 'components/shared/Loader'
import { withoutAuthOnly } from 'hocs/withoutAuthOnly'

const AuthLayoutInternal: FC = () => (
  <Container maxWidth="xs" sx={{ pt: 10 }}>
    <Logo />
    <Box sx={{ mt: 12 }}>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </Box>
  </Container>
)

export const AuthLayout = withoutAuthOnly(AuthLayoutInternal)
